import axios from 'axios'
/* handles the download of a file
@params url - the url from where the file will be download
@return promise - the fullfilled promise
@return promise - a rejected promised with the error
*/
export const fileDownloader = async (url, customFileName, fallbackName) => {
	try {
		const res = await request(url)
		const { file, name } = buildBlob(res, customFileName, url, fallbackName)
		setupAndDownloadFile(file, name)
		return Promise.resolve()
	} catch (err) {
		return Promise.reject(arrayBufferToJson(err))
	}
}

/** handles the download of a file and returns it's blob
@url { string } - the url from where the file will be download
@return { promise } - the fullfilled promise
@return { promise } - a rejected promised with the error
*/
export const fileDownloaderForPdfViewer = async url => {
	try {
		const res = await request(url)
		return Promise.resolve(res)
	} catch (err) {
		if (err) return Promise.reject(arrayBufferToJson(err))
	}
}

/*******************************************
*                  SUPPORT                 *
*******************************************/

/* perform the request
@params url - the url to the request
@return promise - the response to the request
*/
const request = url => {
	return axios({
		method: 'GET',
		url: url,
		responseType: 'arraybuffer'
	})
}

/* build the blob based on the response
@params res - the response from the server with the file as
an array buffer
@return file - the blob built using the arraybuffer from the res
@return name - the name of the file to be displayed
*/
const buildBlob = (res, customFileName, url, fallbackName) => {
	const type = res.headers['content-type']
	const data = res.request.response

	let name
	if (customFileName) name = customFileName
	else if (res.headers['content-disposition']) {
		const splitVariable = res.headers['content-disposition'].includes('fileName') ? 'fileName=' : 'filename='
		name = res.headers['content-disposition'].split(splitVariable)[1]
	} else {
		const splitedUrl = url.split('/')
		name = url.includes('?') ? 'Document' : splitedUrl[splitedUrl.length - 1]
	}

	name = name.replaceAll('"', '')
	const file = new Blob([data], { type: getContentTypeByExtension(type, name) })
	return { file, name }
}

const getContentTypeByExtension = (type, name) => {
    switch (name.replace(/^.*(?=[.]\w+$)/, '')) {
        case '.xlsx':
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        default:
            return type
    }
}

/* calls the setup function and then
executes the download
@params file - the blob to be downloaded
@params name - the name of the file
*/
const setupAndDownloadFile = (file, name) => {
	const downloader = setupDownloadTrigger()
	downloader(file, name)
}

/* create the needed DOM setup to download the file
@return function - will perform the download when called
NOTE - this step is only necessary if you care about the
name of the file
*/
const setupDownloadTrigger = () => {
	const trigger = document.createElement('a')
	/* Added this class to prevent downloading from closing our side-modal */
	trigger.classList.add('dont-close-side-modals')
	trigger.classList.add('is-download-click')
	document.body.appendChild(trigger)
	trigger.style = 'display:none'
	return (file, name) => {
		const fileURL = URL.createObjectURL(file)
		trigger.href = fileURL
		trigger.download = name
		trigger.click()
		window.URL.revokeObjectURL(fileURL)
		trigger.remove()
	}
}

/* converts an array buffer back to json, this is
used to parse the message in case of error
@parmas err - the error containing the array buffer message
@returns json - the error containing a json version of the message
*/
const arrayBufferToJson = err => {
	if (!err.response) return err
	const intArray = new Uint8Array(err.response.data)
	const decodedString = fromUTF8Array(intArray)
	return JSON.parse(decodedString)
}

/* decode an UTF8 array
@params data - a Uint8Array
@return str - a decoded string of the array
*/
const fromUTF8Array = (data) => {
	var str = ''
	var i

	for (i = 0; i < data.length; i++) {
		var value = data[i]

		if (value < 0x80) {
			str += String.fromCharCode(value)
		} else if (value > 0xBF && value < 0xE0) {
			str += String.fromCharCode((value & 0x1F) << 6 | data[i + 1] & 0x3F)
			i += 1
		} else if (value > 0xDF && value < 0xF0) {
			str += String.fromCharCode((value & 0x0F) << 12 | (data[i + 1] & 0x3F) << 6 | data[i + 2] & 0x3F)
			i += 2
		} else {
			// surrogate pair
			var charCode = ((value & 0x07) << 18 | (data[i + 1] & 0x3F) << 12 | (data[i + 2] & 0x3F) << 6 | data[i + 3] & 0x3F) - 0x010000

			str += String.fromCharCode(charCode >> 10 | 0xD800, charCode & 0x03FF | 0xDC00)
			i += 3
		}
	}

	return str
}
